export const WHEEL_HASH_CONSUME_START = 'WHEEL_HASH_CONSUME_START';
export const WHEEL_HASH_CONSUME_SUCCESS = 'WHEEL_HASH_CONSUME_SUCCESS';
export const WHEEL_HASH_CONSUME_FAIL = 'WHEEL_HASH_CONSUME_FAIL';
export const WHEEL_HASH_CONSUME_RESET = 'WHEEL_HASH_CONSUME_RESET';